module.exports = __webpack_public_path__ + "img/IMG_8903.37ed1a8e.jpg";